import React, { FC } from "react";
import Button from "@mui/material/Button";
import css from "./styles.module.scss";
import { RxUpdate } from "react-icons/rx";
import { useGeneratorPrivateHash } from "./hook/useGeneratorPrivateHash";

const GeneratorPrivateHash: FC = () => {
  const { hash, onGenerateHash } = useGeneratorPrivateHash();
  return (
    <div className={css.GeneratorPrivateHash}>
      <div className={css.GeneratorPrivateHash_result}>{hash}</div>
      <div className={css.GeneratorPrivateHash_btn}>
        <Button variant="outlined" size="small" onClick={onGenerateHash}>
          <RxUpdate />
        </Button>
      </div>
    </div>
  );
};

export default GeneratorPrivateHash;
